const initialState = {
    theme: localStorage.getItem("data-theme") || "light",
    isSidebarExpanded: true
};


export {initialState};